import { PACKET_ITEMS } from './packetData'

/** The "what to send" list. Scrolls with the page — a capped height gave it its own scrollbar. */
export function PacketChecklist() {
  return (
    <aside className="border-ink-700 flex flex-col gap-6 rounded-md border p-7 lg:self-start">
      {/* Still an h3 for the document outline — the eyebrow is styling, not a demotion. */}
      <h3 className="text-ink-300 font-mono text-xs tracking-[0.14em] uppercase">What to send</h3>
      <ul className="flex flex-col gap-5">
        {PACKET_ITEMS.map((item) => (
          <li
            key={item.label}
            className="border-ink-700 flex flex-col gap-1.5 border-t pt-5 first:border-0 first:pt-0"
          >
            <div className="flex items-baseline justify-between gap-3">
              <span className="text-ink-50 text-sm font-semibold">{item.label}</span>
              {/* Needed is the default, so only the optional items are labelled. */}
              {item.importance === 'Helpful' && (
                <span className="text-ink-300 shrink-0 font-mono text-[10px] tracking-[0.12em] uppercase">
                  {item.importance}
                </span>
              )}
            </div>
            <p className="text-ink-300 text-sm leading-relaxed">{item.detail}</p>
          </li>
        ))}
      </ul>
      <p className="text-ink-300 border-ink-700 border-t pt-6 text-xs leading-normal">
        Send whatever you have. We&apos;ll work with you, your insurance provider, and current insurance
        broker to gather whatever is missing.
      </p>
    </aside>
  )
}
